import { FC, useState } from "react";
import { InputType } from "../../../types/InputType";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import BaseModal from "../../modals/BaseModal";
import FilterIconSVG from "../../shared/svg/FilterIconSVG";
import CustomInput from "../../../custom-components/form-inputs/CustomInput";
import { ProductFeatureDTO } from "../../../domain/models/dto/ProductFeatureDTO";
import { productFeaturesFiltersFields } from "../../../validation-schemas/ProductFeaturesFiltersFields";

interface ProductFeaturesSearchFiltersFormProps {
    form: FormikProps<ProductFeatureDTO>;
    filtersFields: ProductFeatureDTO;
}

const ProductFeatureSearchFiltersForm: FC<ProductFeaturesSearchFiltersFormProps> = (props) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const confirmHandler = () => {
        setIsVisible(false);
        props.form.handleSubmit();
    };
    const closeHandler = () => {
        props.form.resetForm();
    };
    const onOpenHandler = () => {
        props.form.setValues(props.filtersFields);
    };
    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={t("console.common.filters")}
            confirmTitle={t("console.common.apply")}
            cancelTitle={t("console.common.cancel")}
            buttonElement={
                <button
                    data-modal-target="static-modal"
                    data-modal-toggle="static-modal"
                    className="flex items-center text-white bg-light-bg-300 dark:bg-dark-bg-300 hover:bg-light-bg-300 dark:hover:bg-dark-bg-300 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2.5 text-center max-h-10"
                    type="button"
                    title={t("console.common.filters")}
                    onClick={() => setIsVisible(true)}
                >
                    <FilterIconSVG className="w-[20px] fill-white" />
                </button>
            }
            confirmHandler={confirmHandler}
            closeHandler={closeHandler}
            onOpen={onOpenHandler}
            additionalWrapClassName="w-[450px]"
        >
            <CustomInput
                type={productFeaturesFiltersFields.name.type as InputType}
                value={props.form.values.name}
                name="name"
                placeholderKey={productFeaturesFiltersFields.name.placeholderKey}
                errorKey={props.form.errors.name as string}
                onChange={props.form.handleChange}
            />
            <CustomInput
                type={productFeaturesFiltersFields.description.type as InputType}
                value={props.form.values.description}
                name="description"
                placeholderKey={productFeaturesFiltersFields.description.placeholderKey}
                errorKey={props.form.errors.description as string}
                onChange={props.form.handleChange}
            />
        </BaseModal>
    );
};

export default ProductFeatureSearchFiltersForm;
